module.exports = __webpack_public_path__ + "static/media/icons_Bilan Cheville et Pied.2976149b.svg";